export default {
  productName: 'Product Name',
  pay: 'PAY',
  payTokenLack: 'Query payToken needed! Please contact us for help',
  payTokenInvalid: 'PayToken and payChannel Mismatch! Please contact us for help',
  noPayChannel: 'No available payment channel',
  currencyMismatch: 'Cannot proceed with wrong currency, please try another channel or contact us',
  networkError: 'Internet server unavailable, please try later.',
  invokeTimeoutNotice: 'The payment result is still on the way... Please check your order status and retry later.',
  ok: 'OK',
  paymentMethodNotSupported: 'This payment method is not supported, please try another one',
  enterCompleteInfo: 'Please enter the complete information.',
  enterCorrectInfo: 'Please enter the correct XXX',
  sendOtpCode: 'SEND',
  textOnairNext: 'NEXT',
  voteCancel: 'CANCEL',
  paymentSuccessful: 'Payment Successful',
  paymentSuccessfulDesc: 'Thanks for your payment. Your order has been successfully paid. Please click "OK" if you are not redirected within 10s.',
  paymentFailed: 'Payment Failed',
  refresh: 'REFRESH',
  orderIdEmpty: 'Order id is empty, invalid request. Please contact us for help',
  waitingMessage: 'Processing you payment, please wait for a moment',
  resultTimeoutNotice: 'Transaction timeout, we are still processing your payment and it may take longer time. The result will be refreshed immediately when it comes, thanks for your patience.'
}
